import { Conversation } from 'ha/services/apiV2/types/Conversation';
import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

type UserId = number | 'me';

interface Query {
  expand?: string;
  excludeMoveOutOlderThan?: number;
  asAdvertiser?: boolean;
  state?: 'paidAndCancelled';
  listingId?: string;
  asTenant?: boolean;
}

interface Payload {
  conversations: Conversation[];
  count: number;
}

export default (makeCall: MakeCall) => (userId: UserId, query?: Query) =>
  makeCall<Payload>('GET', `${APIV2_URL}/conversations/user/${userId}`, {
    query,
  });
